<script>
import RadioGroup from '@/components/pc/radio/ipradio/atoms/RadioGroup.vue'
import SelectBox from '@/components/pc/radio/ipradio/atoms/SelectBox.vue'
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC, BC_TRANS_JP } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'

export default {
  components: {
    RadioGroup,
    SelectBox,
    ToggleSwitch,
    SettingGroup,
    SettingItem
  },

  data() {
    // ========== 静的変数 ==========
    const radioBtnOptions = {
      pttHold: {
        pttHoldFunction: Object.keys(BC.OPTIONAL_FEATURES.KEY_FUNCTION.PTT_HOLD.PTT_HOLD_FUNCTION).map(
          (key) => {
            return {
              label: BC_TRANS_JP.OPTIONAL_FEATURES.KEY_FUNCTION.PTT_HOLD.PTT_HOLD_FUNCTION[key],
              value: BC.OPTIONAL_FEATURES.KEY_FUNCTION.PTT_HOLD.PTT_HOLD_FUNCTION[key],
            }
          },
        ),
      },
      secondPttGroup: {
        secondPttTransmissionStartTime: Object.keys(
          BC.OPTIONAL_FEATURES.KEY_FUNCTION.SECOND_PTT_GROUP.SECOND_PTT_TRANSMISSION_START_TIME,
        ).map((key) => {
          return {
            label:
              BC_TRANS_JP.OPTIONAL_FEATURES.KEY_FUNCTION.SECOND_PTT_GROUP
                .SECOND_PTT_TRANSMISSION_START_TIME[key],
            value:
              BC.OPTIONAL_FEATURES.KEY_FUNCTION.SECOND_PTT_GROUP.SECOND_PTT_TRANSMISSION_START_TIME[
                key
              ],
          }
        }),
      },
    }

    const selectboxOptions = {
      secondPttGroup: {
        pttActionOnSecondGroup: Object.keys(
          BC.OPTIONAL_FEATURES.KEY_FUNCTION.SECOND_PTT_GROUP.PTT_ACTION_ON_SECOND_GROUP,
        ).map((key) => {
          return {
            label:
              BC_TRANS_JP.OPTIONAL_FEATURES.KEY_FUNCTION.SECOND_PTT_GROUP.PTT_ACTION_ON_SECOND_GROUP[
                key
              ],
            value: BC.OPTIONAL_FEATURES.KEY_FUNCTION.SECOND_PTT_GROUP.PTT_ACTION_ON_SECOND_GROUP[key],
          }
        }),
      },
      control: {
        superLock: Object.keys(BC.OPTIONAL_FEATURES.KEY_FUNCTION.CONTROL.SUPER_LOCK)
          .filter((key) => {
            return key !== 'DISABLE'
          })
          .map((key) => {
            return {
              label: BC_TRANS_JP.OPTIONAL_FEATURES.KEY_FUNCTION.CONTROL.SUPER_LOCK[key],
              value: BC.OPTIONAL_FEATURES.KEY_FUNCTION.CONTROL.SUPER_LOCK[key],
            }
          }),
      },
    }

    return {
      radioSettings: null,
      radioBtnOptions,
      selectboxOptions,
      // ========== リアクティブ変数 ==========
      form: {
        radioBtn: {
          pttHold: {
            pttHoldFunction: radioBtnOptions.pttHold.pttHoldFunction[0].value,
          },
          secondPttGroup: {
            secondPttTransmissionStartTime:
              radioBtnOptions.secondPttGroup.secondPttTransmissionStartTime[0].value,
          },
        },
        selectbox: {
          secondPttGroup: {
            pttActionOnSecondGroup: selectboxOptions.secondPttGroup.pttActionOnSecondGroup[0].value,
          },
          control: {
            superLock: selectboxOptions.control.superLock[0].value,
          },
        },
        toggle: {
          secondPttGroup: {
            secondPttBeep: false,
          },
          control: {
            superLock: false,
            quickScroll: false,
          },
        },
      },
      setting: null
    }
  },

  computed: {
    BC() {
      return BC
    }
  },

  watch: {
    form: {
      handler() {
        // フォームの内容を端末設定データに変換して反映
        this.transForm2Setting()
        // 最新の状態をストアの仮保存端末設定情報にも適用
        this.radioSettings.saveTempSetting(this.setting)
      },
      deep: true
    }
  },

  created() {
    // ストアに仮保存済みの端末設定情報を取得する
    this.radioSettings = useRadioSettingsStore()
    this.setting = this.radioSettings.getTempSetting()
    this.transSetting2Form()
  },

  methods: {
    // ========== methods ==========
    transForm2Setting() {
      const data = this.setting.OptionalFeatures.KeyFunction

      console.log('============================')
      console.log('before setting: ', JSON.parse(JSON.stringify(data)))

      data.PTTHold.PTTHoldFunction = this.form.radioBtn.pttHold.pttHoldFunction

      data.SecondPTTGroup.SecondPTTTransmissionStartTime =
        this.form.radioBtn.secondPttGroup.secondPttTransmissionStartTime
      data.SecondPTTGroup.PTTActionOnSecondGroup =
        this.form.selectbox.secondPttGroup.pttActionOnSecondGroup
      data.SecondPTTGroup.SecondPTTBeep = this.form.toggle.secondPttGroup.secondPttBeep
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      data.Control.SuperLock = this.form.toggle.control.superLock
        ? this.form.selectbox.control.superLock
        : BC.COMMON.TOGGLE.DISABLE
      data.Control.QuickScroll = this.form.toggle.control.quickScroll
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE

      console.log('after setting: ', JSON.parse(JSON.stringify(data)))
    },

    transSetting2Form() {
      const data = this.setting.OptionalFeatures.KeyFunction

      console.log('============================')
      console.log('before form: ', JSON.parse(JSON.stringify(this.form)))

      this.form.radioBtn.pttHold.pttHoldFunction = data.PTTHold.PTTHoldFunction

      this.form.radioBtn.secondPttGroup.secondPttTransmissionStartTime =
        data.SecondPTTGroup.SecondPTTTransmissionStartTime
      this.form.selectbox.secondPttGroup.pttActionOnSecondGroup =
        data.SecondPTTGroup.PTTActionOnSecondGroup
      this.form.toggle.secondPttGroup.secondPttBeep =
        data.SecondPTTGroup.SecondPTTBeep === BC.COMMON.TOGGLE.ENABLE

      this.form.toggle.control.superLock = data.Control.SuperLock !== BC.COMMON.TOGGLE.DISABLE
      this.form.selectbox.control.superLock =
        data.Control.SuperLock !== BC.COMMON.TOGGLE.DISABLE
          ? data.Control.SuperLock
          : BC.OPTIONAL_FEATURES.KEY_FUNCTION.CONTROL.SUPER_LOCK.TX_ALLOWED
      this.form.toggle.control.quickScroll = data.Control.QuickScroll === BC.COMMON.TOGGLE.ENABLE

      console.log('after form: ', JSON.parse(JSON.stringify(this.form)))
    },

    handleSelectPTTActionOnSecondGroup(value) {
      this.form.selectbox.secondPttGroup.pttActionOnSecondGroup = value
    },

    handleSelectSuperLock(value) {
      this.form.selectbox.control.superLock = value
    }
  }
}
</script>

<template>
  <div>
    <SettingGroup title="PTT ホールド">
      <SettingItem label="PTT ホールド">
        <RadioGroup
          v-model="form.radioBtn.pttHold.pttHoldFunction"
          :options="radioBtnOptions.pttHold.pttHoldFunction"
          :disable="false"
        />
      </SettingItem>
    </SettingGroup>

    <SettingGroup title="セカンド PTT グループ">
      <SettingItem label="セカンド PTT 送信開始時間">
        <RadioGroup
          v-model="form.radioBtn.secondPttGroup.secondPttTransmissionStartTime"
          :options="radioBtnOptions.secondPttGroup.secondPttTransmissionStartTime"
          :disable="false"
        />
      </SettingItem>
      <SettingItem label="セカンド・グループ表示中のPTT動作">
        <SelectBox
          :disabled="false"
          :options="selectboxOptions.secondPttGroup.pttActionOnSecondGroup"
          :defaultValue="form.selectbox.secondPttGroup.pttActionOnSecondGroup"
          @update="handleSelectPTTActionOnSecondGroup"
        />
      </SettingItem>
      <SettingItem label="セカンド PTT ビープ音">
        <ToggleSwitch
          v-model="form.toggle.secondPttGroup.secondPttBeep"
          :disable="false"
        />
      </SettingItem>
    </SettingGroup>

    <SettingGroup title="キー制御">
      <SettingItem label="スーパー・ロック">
        <ToggleSwitch v-model="form.toggle.control.superLock" :disable="false" />
        <SelectBox
          :disabled="!form.toggle.control.superLock"
          :options="selectboxOptions.control.superLock"
          :defaultValue="form.selectbox.control.superLock"
          @update="handleSelectSuperLock"
        />
      </SettingItem>
      <SettingItem label="高速スクロール">
        <ToggleSwitch v-model="form.toggle.control.quickScroll" :disable="false" />
      </SettingItem>
    </SettingGroup>
  </div>
</template>
